function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_14097",
  width: 512,
  height: 512,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_79364",
  transform: "translate(23378 14064)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_14096",
  width: 512,
  height: 512,
  rx: 256,
  transform: "translate(-23378 -14064)",
  fill: "#ff0660"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_79363",
  transform: "translate(-23378 -14064)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_222",
  d: "M23518.965,14239.452a198.353,198.353,0,0,1-74.283-16.3,220.09,220.09,0,0,1-32.3-17.172c-5.016-3.41-10.02-6.753-14.744-10.557a156.365,156.365,0,0,1-14.045-12.413,18.67,18.67,0,0,1,.17-26.821,19.74,19.74,0,0,1,19.307-4.645l2.92.889c4.209,1.261,9.4,3.281,14.174,4.868,4.883,1.634,9.7,3.368,14.6,4.847,9.729,3.092,19.4,5.893,28.982,8.271,19.158,4.834,38,7.668,56.014,7.926a230.575,230.575,0,0,0,28.133-1.506c9.533-.888,19.152-2.562,28.889-4.447s19.543-4.2,29.408-6.8c4.982-1.207,9.885-2.665,14.852-4.04,4.828-1.329,10.15-3.059,14.389-4.062l3.066-.726a19.439,19.439,0,0,1,23.436,13.973,18.74,18.74,0,0,1-5.635,18.359,157.231,157.231,0,0,1-14.676,11.824c-4.937,3.54-10.082,6.7-15.275,9.858a210.44,210.44,0,0,1-33.123,15.519,205.98,205.98,0,0,1-71.77,13.169C23520.621,14239.469,23519.8,14239.463,23518.965,14239.452Zm-80.109-151.066c16.383-31.763,151.107-33.255,162.729,0,8.6,24.6-47.209,59.194-81.363,59.194C23482.8,14147.586,23426.746,14111.892,23438.855,14088.386Z",
  transform: "translate(-23264.238 -13895.736)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
})));

function SvgPerfectAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectAvatar);
export default __webpack_public_path__ + "static/media/perfect-avatar.590174b4.svg";
export { ForwardRef as ReactComponent };